import { CALL_API } from "../../middlewares/api";
import moment from "moment/moment";

export const USERS_LIST_GET_REQUEST = "USERS_LIST_GET_REQUEST";
export const USERS_LIST_GET_SUCCESS = "USERS_LIST_GET_SUCCESS";
export const USERS_LIST_GET_ERROR = "USERS_LIST_GET_ERROR";

export function get_users(query) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/accountinfo/byquery?query=" + query,
      authenticatedRequest: true,
      types: [
        USERS_LIST_GET_REQUEST,
        { method: get_users_success },
        USERS_LIST_GET_ERROR,
      ],
    },
  };
}

function get_users_success(response) {
  return (dispatch) => {
    dispatch({
      type: USERS_LIST_GET_SUCCESS,
      response,
    });

    const data = Array.isArray(response) ? response : [response];
    let selected = data[0];

    if (data.length > 1 && data[1].Domain === "Loanstep") {
      selected = data[1];
    }

    const currentUser =
      data.length > 0 ? Object.assign({}, {}, selected) : null;

    //TODO needs a proper fix Adam please have a look at this (this creates an issue... if 2 accounts are available only one account info is populated)
    if (currentUser) dispatch(account_info_fetch_ssn(currentUser.Id));
  };
}

export const SHOW_USER_ACCOUNT = "SHOW_USER_ACCOUNT";

export function show_account(domain, id) {
  return {
    type: SHOW_USER_ACCOUNT,
    domain,
    Id: id,
  };
}

export const USERS_CHANGE_FILTER = "USERS_CHANGE_FILTER";

export function change_user_filter(value) {
  return {
    type: USERS_CHANGE_FILTER,
    value,
  };
}

export const AD_HOC_USER_GET_REQUEST = "AD_HOC_USER_GET_REQUEST";
export const AD_HOC_USER_GET_SUCCESS = "AD_HOC_USER_GET_SUCCESS";
export const AD_HOC_USER_GET_ERROR = "AD_HOC_USER_GET_ERROR";

export function get_ad_hoc_complete_data_for_credit_id(
  creditId,
  types = [
    AD_HOC_USER_GET_REQUEST,
    AD_HOC_USER_GET_SUCCESS,
    AD_HOC_USER_GET_ERROR,
  ],
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayments/completed?creditId=" + creditId,
      method: "GET",
      authenticatedRequest: true,
      additionalData: creditId,
      types,
    },
  };
}

export const AD_HOC_USER_PENDING_GET_REQUEST =
  "AD_HOC_USER_PENDING_GET_REQUEST";
export const AD_HOC_USER_PENDING_GET_SUCCESS =
  "AD_HOC_USER_PENDING_GET_SUCCESS";
export const AD_HOC_USER_PENDING_GET_ERROR = "AD_HOC_USER_PENDING_GET_ERROR";

export function get_ad_hoc_pending_data_for_credit_id(
  creditId,
  types = [
    AD_HOC_USER_PENDING_GET_REQUEST,
    AD_HOC_USER_PENDING_GET_SUCCESS,
    AD_HOC_USER_PENDING_GET_ERROR,
  ],
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayments/pending?creditId=" + creditId,
      method: "GET",
      authenticatedRequest: true,
      additionalData: creditId,
      types,
    },
  };
}

// New way of fetching accountinfos

export const USER_DATA_GET_REQUEST = "USER_DATA_GET_REQUEST";
export const USER_DATA_GET_SUCCESS = "USER_DATA_GET_SUCCESS";
export const USER_DATA_GET_ERROR = "USER_DATA_GET_ERROR";

export function get_user_data_for_account_id(
  accountId,
  types = [USER_DATA_GET_REQUEST, USER_DATA_GET_SUCCESS, USER_DATA_GET_ERROR],
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/accountinfo/byaccountid?accountId=" + accountId,
      method: "GET",
      authenticatedRequest: true,
      additionalData: accountId,
      types,
    },
  };
}

export function get_account_infos_for_users(accountIds, fetchSSN) {
  return (dispatch) => {
    if (accountIds.length > 0) {
      dispatch(
        get_user_data_for_account_id(accountIds[0], [
          USER_DATA_GET_REQUEST,
          { method: account_info_fetched.bind(this, accountIds, fetchSSN) },
          USER_DATA_GET_ERROR,
        ]),
      );
    }
  };
}

function account_info_fetched(accountIds, fetchSSN, response) {
  return (dispatch) => {
    dispatch({
      type: USER_DATA_GET_SUCCESS,
      additionalData: accountIds[0],
      response,
    });

    if (fetchSSN) {
      dispatch(account_info_fetch_ssn(accountIds));
    } else {
      accountIds.splice(0, 1);
      dispatch(get_account_infos_for_users(accountIds));
    }
  };
}

export const USER_DATA_GET_SSN_REQUEST = "USER_DATA_GET_SSN_REQUEST";
export const USER_DATA_GET_SSN_SUCCESS = "USER_DATA_GET_SSN_SUCCESS";
export const USER_DATA_GET_SSN_ERROR = "USER_DATA_GET_SSN_ERROR";

export function account_info_fetch_ssn(accountIds) {
  let id = "";
  let succes;
  if (Array.isArray(accountIds)) {
    id = accountIds[0];
    succes = { method: account_info_fetched_ssn.bind(this, accountIds) };
  } else {
    id = accountIds;
    succes = USER_DATA_GET_SSN_SUCCESS;
  }

  let endpoint = "/api/admin/accountclaims/ssn?accountId=" + id;

  return {
    [CALL_API]: {
      endpoint,
      method: "GET",
      authenticatedRequest: true,
      additionalData: id,
      types: [USER_DATA_GET_SSN_REQUEST, succes, USER_DATA_GET_SSN_ERROR],
    },
  };
}

function account_info_fetched_ssn(accountIds, response) {
  return (dispatch) => {
    dispatch({
      type: USER_DATA_GET_SSN_SUCCESS,
      additionalData: accountIds[0],
      response,
    });

    accountIds.splice(0, 1);
    dispatch(get_account_infos_for_users(accountIds));
  };
}

// add bank Account

export const USER_ADD_BANK_ACCOUNT_REQUEST = "USER_ADD_BANK_ACCOUNT_REQUEST";
export const USER_ADD_BANK_ACCOUNT_SUCCESS = "USER_ADD_BANK_ACCOUNT_SUCCESS";
export const USER_ADD_BANK_ACCOUNT_ERROR = "USER_ADD_BANK_ACCOUNT_ERROR";

export function add_bank_account(
  data,
  accountId,
  types = [
    USER_ADD_BANK_ACCOUNT_REQUEST,
    USER_ADD_BANK_ACCOUNT_SUCCESS,
    USER_ADD_BANK_ACCOUNT_ERROR,
  ],
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/AddBankAccount",
      method: "POST",
      data: data,
      additionalData: accountId,
      authenticatedRequest: true,
      types,
    },
  };
}

// add user claim

export const USER_CUSTOM_CLAIM_SET_REQUEST = "USER_CUSTOM_CLAIM_SET_REQUEST";
export const USER_CUSTOM_CLAIM_SET_SUCCESS = "USER_CUSTOM_CLAIM_SET_SUCCESS";
export const USER_CUSTOM_CLAIM_SET_ERROR = "USER_CUSTOM_CLAIM_SET_ERROR";

export function set_user_custom_claim(data) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/claims/set",
      method: "POST",
      data: data,
      authenticatedRequest: true,
      types: [
        USER_CUSTOM_CLAIM_SET_REQUEST,
        USER_CUSTOM_CLAIM_SET_SUCCESS,
        USER_CUSTOM_CLAIM_SET_ERROR,
      ],
    },
  };
}

// set users investorlevel

export const USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_REQUEST =
  "USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_REQUEST";
export const USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_SUCCESS =
  "USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_SUCCESS";
export const USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_ERROR =
  "USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_ERROR";

export function set_user_investor_level_minEffecive(investorLevel, accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/investors/set-min-level",
      method: "POST",
      data: { Level: investorLevel, InvestorId: accountId },
      authenticatedRequest: true,
      types: [
        USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_REQUEST,
        { method: investorinfo_update.bind(this, accountId) },
        USER_INVESTOR_LEVEL_MINEFFECTIVE_SET_ERROR,
      ],
    },
  };
}

// set investor's tag
export const USER_INVESTOR_TAG_SET_REQUEST = "USER_INVESTOR_TAG_SET_REQUEST";
export const USER_INVESTOR_TAG_SET_SUCCESS = "USER_INVESTOR_TAG_SET_SUCCESS";
export const USER_INVESTOR_TAG_SET_ERROR = "USER_INVESTOR_TAG_SET_ERROR";
export function set_user_investor_tag(tag, accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/investors/set-tag",
      method: "POST",
      data: { Type: tag, InvestorId: accountId },
      authenticatedRequest: true,
      types: [
        USER_INVESTOR_TAG_SET_REQUEST,
        { method: investorinfo_update.bind(this, accountId) },
        USER_INVESTOR_TAG_SET_ERROR,
      ],
    },
  };
}

// Set representative

export const USER_SALESREP_SET_REQUEST = "USER_SALESREP_SET_REQUEST";
export const USER_SALESREP_SET_SUCCESS = "USER_SALESREP_SET_SUCCESS";
export const USER_SALESREP_SET_ERROR = "USER_SALESREP_SET_ERROR";

export function set_user_salesrepresentative(
  investorId,
  salesrepId,
  changeDate,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/set-sales-representative",
      method: "POST",
      data: {
        InvestorId: investorId,
        SalesRepresentativeId: salesrepId,
        ChangeDate: moment(changeDate).format("YYYY-MM-DD"),
      },
      authenticatedRequest: true,
      types: [
        USER_SALESREP_SET_REQUEST,
        USER_SALESREP_SET_SUCCESS,
        USER_SALESREP_SET_ERROR,
      ],
    },
  };
}

export const USER_SALESREP_REMOVE_REQUEST = "USER_SALESREP_REMOVE_REQUEST";
export const USER_SALESREP_REMOVE_SUCCESS = "USER_SALESREP_REMOVE_SUCCESS";
export const USER_SALESREP_REMOVE_ERROR = "USER_SALESREP_REMOVE_ERROR";

export function remove_user_salesrepresentative(investorId, changeDate) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/remove-sales-representative",
      method: "POST",
      data: {
        InvestorId: investorId,
        ChangeDate: moment(changeDate).format("YYYY-MM-DD"),
      },
      authenticatedRequest: true,
      types: [
        USER_SALESREP_REMOVE_REQUEST,
        USER_SALESREP_REMOVE_SUCCESS,
        USER_SALESREP_REMOVE_ERROR,
      ],
    },
  };
}

export const USER_GET_INVESTOR_TAGS_REQUEST = "USER_GET_INVESTOR_TAGS_REQUEST";
export const USER_GET_INVESTOR_TAGS_SUCCESS = "USER_GET_INVESTOR_TAGS_SUCCESS";
export function get_investor_tags(
  types = [USER_GET_INVESTOR_TAGS_REQUEST, USER_GET_INVESTOR_TAGS_SUCCESS, ""],
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/get-investor-tags",
      method: "GET",
      authenticatedRequest: true,
      types,
    },
  };
}

function investorinfo_update(accountId) {
  return (dispatch) => {
    // eslint-disable-next-line no-undef
    dispatch({ type: USER_INVESTOR_TAG_SET_SUCCESS, response });
    dispatch(get_account_infos_for_users([accountId]));
  };
}
